export const MQTT_OFFLINE = "offline"
export const MQTT_ONLINE = "online"



// WEBPACK FOOTER //
// ./src/services/mqtt/common/constants.js